import { render, staticRenderFns } from "./ProjectReport.vue?vue&type=template&id=83f86b2c&"
import script from "./ProjectReport.vue?vue&type=script&lang=js&"
export * from "./ProjectReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports